import { APP_API_URL, APP_DOMAIN } from "../constants";

export const domainURL = (path: string) => {
  const arr = path.split("/").filter((item) => item.length);
  return `${APP_DOMAIN}${arr.join("/")}`;
};

export const apiURL = (path: string) => {
  const arr = path.split("/").filter((item) => item.length);
  return `${APP_API_URL}${arr.join("/")}`;
};

const url = {
  upload: {
    audio(fileName: string) {
      return apiURL(`/upload/audio/file/${fileName}`);
    },
    analyze: apiURL(`/upload/audio/analyze`),
    getFile(id: number) {
      return apiURL(`/upload/file/${id}`)
    },
    get(id: number) {
      return apiURL(`/upload/${id}`)
    },
    delete(id: number) {
      return apiURL(`/upload/${id}`)
    }
  },
  track: {
    editFrontend(trackId: number, uploadId: number | undefined = undefined) {
      if (uploadId) {
        const params = new URLSearchParams({
          "file-id": uploadId.toString()
        })
        return `/track/edit/${trackId}?${params.toString()}`;
      }
      else return `/track/edit/${trackId}`;
    },
    duplicateFrontend(trackId: number, uploadId: number | undefined = undefined) {
      if (uploadId) {
        const params = new URLSearchParams({
          "file-id": uploadId.toString()
        })
        return `/track/duplicate/${trackId}?${params.toString()}`;
      }
      else return `/track/duplicate/${trackId}`;
    },
    newFrontend(uploadId: number | undefined = undefined) {
      if (uploadId) {
        const params = new URLSearchParams({
          "file-id": uploadId.toString()
        })
        return `/track/new?${params.toString()}`;
      }
      else return `/track/new`;
    }
  },
  genre: {
    all: apiURL(`/genre/all`),
    topGenre: apiURL(`/top-genre`),
    topsubGenre: apiURL(`/top-subgenre`)
  },
  language: {
    all: apiURL(`/language/all`)
  },
  user: {
    new: apiURL("/user/register"),
    login: apiURL("/user/login"),
    resendVerifyEmail: apiURL(`/user/email-verify/resend`),
    resetPassword: apiURL(`/user/reset-password`)
  }
};

export default url;
